import { render, staticRenderFns } from "./FileEditorDialog.vue?vue&type=template&id=79f83f34&"
import script from "./FileEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./FileEditorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports